// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TagSvg from '@rsuite/icon-font/lib/application/Tag';
var Tag = createSvgIcon({
  as: TagSvg,
  ariaLabel: 'tag',
  category: 'application',
  displayName: 'Tag'
});
export default Tag;